/*
 * @Author: COCO
 * @Date: 2018-05-07 13:11:41
 * @Last Modified by: COCO
 * @Last Modified time: 2019-03-04 21:00:50
 * http请求封装
 */
import axios from 'axios';
const instanceAxios = axios.create({
  timeout: 10000
});
let pending = [];
function removePending(promise) {
  pending = pending.filter(value =>
    promise && promise.url !== value.url && promise.method !== value.method && JSON.stringify(promise.params) !== value.params
  );
}
function setPending(promise) {
  pending.push({ url: promise.url, method: promise.method, params: JSON.stringify(promise.params) });
}
function isPending(promise) {
  return pending.filter(value =>
    promise.url === value.url && promise.method === value.method && JSON.stringify(promise.params) === value.params
  );
}
//请求拦截器，根据后端返回的数据做统一处理
instanceAxios.interceptors.request.use(
  req => {
    if (isPending(req).length) {
      return false;
    } else {
      setPending(req);
    }
    return req;
  },
  error => Promise.reject(error)
);

//响应拦截器，根据后端返回的数据做统一处理
instanceAxios.interceptors.response.use(
  res => {
    //TODO:根据数据做处理
    // console.log(res);
    removePending(res.config);
    return res;
  },
  error => {
    removePending(error.config);
    return Promise.reject(error);
  }
);
export default instanceAxios;



// WEBPACK FOOTER //
// ./src/api/request/index.js